import { render, staticRenderFns } from "./user-invite-modal.component.vue?vue&type=template&id=70064c32&scoped=true"
import script from "./user-invite-modal.component.vue?vue&type=script&lang=ts"
export * from "./user-invite-modal.component.vue?vue&type=script&lang=ts"
import style0 from "./user-invite-modal.component.vue?vue&type=style&index=0&id=70064c32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70064c32",
  null
  
)

export default component.exports